function mapGetOneCollateralPriceData(responseData) {
    return {
        ...responseData,
    };
}

function mapGetListCollateralPricesData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

export { mapGetOneCollateralPriceData, mapGetListCollateralPricesData };
